import React, { useEffect, useState } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import TokenRegistrationTable from "../components/TokenRegistrationTable";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@mui/material";
import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import formatDate from "../utilities/formatDate";
import ApiLoader from "../components/ApiLoader";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearUsers } from "../redux-store/slices/partyDetailsSlice";
import REPORT_BASE_URL from "../utilities/ReportConfig";

const PostponedRegistrationTokenList = () => {
  const [tokenList, setTokenList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCheckbox, setSelectedCheckbox] = useState(null);
  const [partyDetailsMode, setPartyDetailsMode] = useState("ALL");

  const [selectedTokenDetails, setSelectedTokenDetails] = useState([]);

  const [selectedItems, setSelectedItems] = useState({});

  const [partyListDetailsPopup, setPartyListDetailsPopup] = useState(false);
  const [registeredPartyList, setRegisteredPartyList] = useState([]);
  const { dcode, srocode } = useSelector((state) => state?.auth?.userDetails);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selectedPartyDetailsArray = Object.keys(selectedItems)
    .filter((pcode) => selectedItems[pcode])
    .map((pcode) => registeredPartyList.find((item) => item.pcode === pcode));

  console.log(
    "selected party data for postponed mode",
    selectedPartyDetailsArray
  );

  const handleGetRegisteredTokenData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${API_BASE_URL}/Registration/get_deed_details_modewise_using_dcode_srocode/${dcode}/${srocode}/ADDPHOTO`
      );
      console.log("all token list", response.data);
      if (response.data?.statusCode === 200) {
        setTokenList(response.data?.deedDetailsList);
      } else {
        toast.error(response.data?.status);
      }
    } catch (error) {
      console.log(error);
      toast.error("Due to Unexpected error can not able to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const handleGetPartyDetailsUsingParameters = async (tokenDetails) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/Registration/get_party_details_modewise_using_dcode_srocode_token_date_token_no/${dcode}/${srocode}/${tokenDetails.tokenDate}/${tokenDetails.tokenNo}/PALL`
      );
      console.log("Registered party list details", response.data);
      if (response.data?.statusCode === 200) {
        setRegisteredPartyList(response.data?.registeredPartyDetailsList);
        // setPartyDetailsListFound(true);
        // alert(`postponed mode selected ${partyDetailsMode}`);
        setPartyListDetailsPopup(true);
      } else {
        toast.error(response.data?.status);
      }
    } catch (error) {
      console.log("handle party details error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRedirectToThumbPhotoAndSignaturePage = async (tokenNo) => {
    setSelectedItems({});
    console.log("token no ", tokenNo);

    const selectedTokenDetails = tokenList.filter((token) => {
      return token.tokenNo === tokenNo;
    });
    console.log("selected token details", selectedTokenDetails);
    setSelectedTokenDetails(selectedTokenDetails);
    console.log("all token list", tokenList);
    if (partyDetailsMode !== "POSTPONED") {
      if (selectedTokenDetails.length > 0) {
        navigate("/PhotoThumbSignForm", {
          state: {
            selectedTokenDetails,
            mode: partyDetailsMode,
            source: "Postpone",
          },
        });
      }
    } else {
      handleGetPartyDetailsUsingParameters(selectedTokenDetails[0]);
      // alert(`postponed mode selected ${partyDetailsMode}`);
    }
  };

  const handlePrintPendingEndorsement = (pendingNo) => {
    // toast.info(`Endorsement Print Button triggered for Pending Number: ${pendingNo}`);
    const filteredRecords = tokenList.filter(
      (record) => record.pendingNo === pendingNo
    );
    console.log(filteredRecords[0]);
    const reportUrl = `${REPORT_BASE_URL}/PostponedEndorsementReprot.aspx?pi_docode=${dcode}&pi_srocode=${srocode}&pi_regyear=${filteredRecords[0].regYear}&pi_regno=${filteredRecords[0].pendingNo}`;
    window.open(reportUrl, "_blank");
  };

  const handlePrintPendingPhoto = (pendingNo) => {
    // toast.info(`Photo Print Button triggered for Pending Number: ${pendingNo}`);
    const filteredRecords = tokenList.filter(
      (record) => record.pendingNo === pendingNo
    );
    console.log(filteredRecords[0]);
    const reportUrl = `${REPORT_BASE_URL}/PostponedPhotoCertificateReport.aspx?pi_docode=${dcode}&pi_srocode=${srocode}&pi_regyear=${filteredRecords[0].regYear}&pi_regno=${filteredRecords[0].pendingNo}`;
    window.open(reportUrl, "_blank");
  };

  const TableData = tokenList?.map((item, index) => ({
    ...item,
    sn: index + 1,
  }));

  const columns = [
    // {
    //     name: "sn",
    //     label: "Serial No",
    //     options: {
    //         filter: false,
    //         sort: true,
    //         customBodyRender: (value) => <div className="text-center">{value}</div>
    //     }
    // },

    {
      name: "pendingNo",
      label: "Pending No",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => <div className="text-start">{value}</div>,
      },
    },
    {
      name: "tokenNo",
      label: "Token No",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => <div className="text-start">{value}</div>,
      },
    },
    {
      name: "tokenDate",
      label: "Token Date",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => <div className="text-start">{value}</div>,
      },
    },
    {
      name: "regYear",
      label: "Registration Year",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start">{formatDate(value, "dd/MM/yyyy")}</div>
        ),
      },
    },
    {
      name: "deed",
      label: "Deed",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => <div className="text-start">{value}</div>,
      },
    },

    {
      name: "subDeed",
      label: "Sub Deed",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => <div className="text-start">{value}</div>,
      },
    },

    {
      name: "tokenNo",
      label: "ACTION",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <button
            className="capitalize px-5 py-1 text-start text-sm rounded-md cursor-pointer bg-primary-600 text-white"
            onClick={() => {
              handleRedirectToThumbPhotoAndSignaturePage(value);
            }}
          >
            Verify
          </button>
        ),
      },
    },
    {
      name: "pendingNo",
      label: "Endorsement",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <button
            className="capitalize px-5 py-1 text-start text-sm rounded-md cursor-pointer bg-primary-600 text-white"
            onClick={() => {
              handlePrintPendingEndorsement(value);
            }}
          >
            Endorsement
          </button>
        ),
      },
    },
    {
      name: "pendingNo",
      label: "Photo",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <button
            className="capitalize px-5 py-1 text-start text-sm rounded-md cursor-pointer bg-primary-600 text-white"
            onClick={() => {
              handlePrintPendingPhoto(value);
            }}
          >
            Photo
          </button>
        ),
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    elevation: 0,
    rowsPerPageOptions: [10, 15, 25, 50],
    responsive: "standard",
    tableBodyHeight: "auto",
    tableBodyMaxHeight: "auto",
    download: false, // Disables the default download (CSV export) button
    print: false, // Disables the default print button
    viewColumns: false, // Disables the default view columns button
    search: true, // Enables the default search button
    customToolbarSelect: () => null, // Hide default toolbar select (if not needed)
  };

  const getMuiTheme = () =>
    createTheme({
      typography: {
        fontFamily: "Poppins",
      },
      palette: {
        background: {
          paper: "#ffffff",
          default: "#ffffff",
        },
        mode: "light",
      },
      components: {
        MuiTableCell: {
          styleOverrides: {
            head: {
              backgroundColor: "#ffffff !important",
              color: "#929292 !important",
              padding: "10px 4px",
              borderBottom: "2px solid #ECECEC",
              borderRight: "0px solid #ddd",
              textAlign: "start",
              "& .MuiTableSortLabel-root": {
                color: "#000000 !important",
                "&.MuiTableSortLabel-active": {
                  color: "#000000 !important",
                },
              },
              "& .MuiTableSortLabel-icon": {
                color: "#000000 !important",
              },
              "&:hover": {
                color: "#000000 !important",
                backgroundColor: "#ffffff !important",
              },
            },
            body: {
              padding: "7px 15px",
              color: "#000000",
              borderBottom: "0px solid #ECECEC",
              borderRight: "0px solid #000000",
            },
            footer: {
              padding: "7px 15px",
              borderBottom: "0px solid #ECECEC",
            },
          },
        },
      },
    });

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    const value = event.target.value;

    if (selectedCheckbox === name) {
      setSelectedCheckbox(null);
      setPartyDetailsMode("ALL");
    } else {
      setSelectedCheckbox(name);
      setPartyDetailsMode(value);
      console.log("name:", name, "value:", value);
    }
    console.log("party details mode", partyDetailsMode);
  };

  const handleApprovePartyListDetails = () => {
    if (selectedPartyDetailsArray.length > 0) {
      navigate("/PhotoThumbSignForm", {
        state: {
          selectedTokenDetails,
          mode: partyDetailsMode,
          source: "Postpone",
          partyListData: selectedPartyDetailsArray,
        },
      });
      setPartyListDetailsPopup(false);
    } else {
      toast.error("Please Select Party Members");
    }
  };

  const handleClosePartyListDetails = () => {
    setPartyListDetailsPopup(false);
  };

  const handlePartyDetailsCheckboxChange = (pcode) => {
    setSelectedItems((prev) => ({
      ...prev,
      [pcode]: !prev[pcode], // Toggle the selected state
    }));
    console.log("selected items", selectedItems);
  };

  useEffect(() => {
    dispatch(clearUsers());
    setSelectedCheckbox(null);
    // setPartyDetailsMode('ALL');
    setPartyDetailsMode("PALL");
    handleGetRegisteredTokenData();
  }, []);

  useEffect(() => {
    console.log("party details mode", partyDetailsMode);
  }, [partyDetailsMode]);

  return (
    <>
      {loading && <ApiLoader />}

      <div className="flex h-screen">
        <SideMenu />
        <div className="flex-1 flex flex-col">
          <Header />
          <div className="flex flex-1">
            {/* Left Side */}
            {/* <div className="flex-1 p-4">
              <h1 className="font-semibold text-xl">Registration Token</h1>
              <div>
                <Box width="100%">
                  <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      title={"Imported Postponed Token"}
                      data={TableData}
                      columns={columns}
                      options={options}
                    />
                  </ThemeProvider>
                </Box>
              </div>
            </div> */}
            <div className="flex-1 p-4">
              <h1 className="font-semibold text-xl">Registration Token</h1>
              <div className="flex">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCheckbox === "book4_2nd_party"}
                      onChange={handleCheckboxChange}
                      name="book4_2nd_party"
                      value="SECOND"
                    />
                  }
                  label="Book No.4 2nd Party Not Present"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCheckbox === "book1_1st_party"}
                      onChange={handleCheckboxChange}
                      name="book1_1st_party"
                      value="FIRST"
                    />
                  }
                  label="Book No.1 1st Party Not Present"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCheckbox === "postponed_document"}
                      onChange={handleCheckboxChange}
                      name="postponed_document"
                      value="POSTPONED"
                    />
                  }
                  label="Postponed Document"
                />
              </div>
              <div className="flex">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCheckbox === "book1_2nd_party"}
                      onChange={handleCheckboxChange}
                      name="book1_2nd_party"
                      value="SECOND"
                    />
                  }
                  label="Book No.1 2nd Party Not Present"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCheckbox === "book6_2nd_party"}
                      onChange={handleCheckboxChange}
                      name="book6_2nd_party"
                      value="SECOND"
                    />
                  }
                  label="Book No.6 2nd Party Not Present"
                />
              </div>

              <div>
                <Box width="100%">
                  <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      title={"Imported Postponed Token"}
                      data={TableData}
                      columns={columns}
                      options={options}
                    />
                  </ThemeProvider>
                </Box>
              </div>
            </div>

            {/* Right Side */}
            <div className="w-64 h-full">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={partyListDetailsPopup}
        onClose={handleApprovePartyListDetails}
      >
        <DialogTitle className="bg-gray-800 text-white">
          Popup Title
        </DialogTitle>
        <DialogContent className="bg-white p-4 px-10">
          <div className="p-6 bg-gray-100 text-lg font-semibold text-gray-800 rounded-lg shadow-md mb-4">
            <div>
              <span>Token No : {selectedTokenDetails[0]?.tokenNo}</span> &nbsp;
              <span>Token Date : {selectedTokenDetails[0]?.tokenDate}</span>
            </div>

            <div>
              {registeredPartyList.map((item, index) => (
                <div key={index} className="flex items-center mb-4">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                      checked={!!selectedItems[item.pcode]}
                      onChange={() =>
                        handlePartyDetailsCheckboxChange(item.pcode)
                      }
                    />
                    <span className="ml-2 text-lg font-semibold text-gray-800">
                      <span className="text-blue-600">
                        {item.nameEng}({item.pcode})
                      </span>
                    </span>
                  </label>
                </div>
              ))}
              {/* <div className="mt-6">
                                <h3 className="text-xl font-bold text-gray-800">Selected Items:</h3>
                                <ul className="list-disc list-inside mt-2">
                                    {Object.keys(selectedItems).filter((key) => selectedItems[key]).map((key) => (
                                        <div key={key} className="text-gray-700">
                                            Pcode No: <span className="font-semibold text-blue-600">{key}</span>
                                        </div>
                                    ))}
                                </ul>
                            </div> */}
              <div>
                <h2 className="text-xl font-bold mt-4 mb-2">
                  Selected Parties:
                </h2>
                {selectedPartyDetailsArray.length === 0 ? (
                  <p>No parties selected.</p>
                ) : (
                  selectedPartyDetailsArray.map((item, index) => (
                    <div key={index} className="flex items-center mb-2">
                      <span className="text-lg font-semibold text-gray-800">
                        <span className="text-blue-600">
                          {item.nameEng}({item.pcode})
                        </span>
                        {/* Name: <span className="text-blue-600">{item?.nameEng}</span>, P Code: <span className="text-blue-600">{item?.pcode}</span> */}
                      </span>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions className="bg-gray-100">
          <Button
            onClick={handleClosePartyListDetails}
            className="bg-red-500 hover:bg-red-700 text-white py-1 px-3 rounded"
          >
            Close
          </Button>
          <Button
            onClick={handleApprovePartyListDetails}
            className="bg-red-500 hover:bg-red-700 text-white py-1 px-3 rounded"
          >
            RedirectToPhotoThumbSign
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PostponedRegistrationTokenList;
